const ErrorMessage = ({ text }) => {
  return (
      <div className="alert alert-danger border border-danger mb-1">
          <i className="fa fa-times-circle" /> {text}
      </div>
  );
};

export default ErrorMessage;